import { observable, action, makeAutoObservable } from "mobx";
import { createContext } from "react";

class AppService {
  @observable navigationOpened = false;

  @observable supportFeedbackOpen = false;

  @observable supportFeedbackSource: string | undefined;

  public history = null;

  constructor() {
    makeAutoObservable(this);
  }

  public setHistory = (history: any) => {
    this.history = history;
  }

  @action public toggleNavigationBar = () => {
    this.navigationOpened = !this.navigationOpened;
  }

  @action public closeNavigationBar = () => {
    this.navigationOpened = false;
  }

  @action public openSupportFeedback = (source?: string) => {
    this.supportFeedbackOpen = true;
    this.supportFeedbackSource = source;
  }

  @action public closeSupportFeedback = () => {
    this.supportFeedbackOpen = false;
    this.supportFeedbackSource = undefined;
  }
}

export const AppServiceInstance = new AppService();

export const AppServiceContext = createContext(AppServiceInstance);
